import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";
import Sidebar from "../SideBar/SideBar";
import "./History.css";
import { getTimeFormat } from "../../Helpers/DateAndTime";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  InputAdornment,
  Modal,
  Radio,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Button,
  Typography,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import nodata from "../../Img/newnodta.gif";
import noodata from "../../Img/no-data.svg";
import coins from "../../Img/coins/coin.svg";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../Loader";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import consts from "../../constant";
import usercalls from "../../Axios";
import { Capitalize, limitLength } from "../../Helpers/StringFunctions";
import ImageWithFallback from "../FallbackImage/ImageWithFallback";
import Footernew from "../Footer/Footernew";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function History() {
  const location = useLocation();
  const { index } = location.state || 0;

  const [value, setValue] = useState(0);

  const [hideZero, setHideZero] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [load, setLoad] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [fiatHistory, setFiatHistory] = useState({});
  const stakeReward = [];

  function decimal(num, decimals = 12) {
    num = Number(num)
    return Number((+num?.toFixed(decimals))?.toString()?.replace(/(\.\d*?[1-9])0+$/g, '$1')?.replace(/\.0+$/, ''));
  }

  const history = [
    {
      sno: 1,
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      asset: "spot asset",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
      action: "claim!",
    },
    {
      sno: 2,
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      asset: "reward asset",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
      action: "claim!",
    },
    {
      sno: 3,
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      asset: "spot asset",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
      action: "claimed!",
    },
    {
      sno: 4,
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      asset: "referral asset",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "Verified!",
      action: "claimed!",
    },
    {
      sno: 5,
      date: "14.25pm",
      currency: coins,
      currencyName: "Dreamster-Exchange",
      asset: "spot asset",
      address: "745689123",
      amount: "35.15",
      txid: "54689234",
      status: "pending!",
      action: "claim!",
    },
  ];
  const filteredData = history.filter((row) => {
    const matchesSearch = row.currencyName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const hasBalance = hideZero ? row.rewards > 0 : true;
    return matchesSearch && hasBalance;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const [status, setStatus] = useState("all");
  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  const [search, setSearch] = useState("");

  const [order_type, setOrder_type] = useState("all");
  const [future_order_type, setFuture_Order_type] = useState("all");
  const handleChangeOrderType = (event) => {
    setOrder_type(event.target.value);
  };
  const handleChangeFutureOrderType = (event) => {
    setFuture_Order_type(event.target.value);
  };

  const [trade_type, setTrade_type] = useState("all");
  const handleChangeTradeType = (event) => {
    setTrade_type(event.target.value);
  };

  const [searchWithdraw, setSearchWithdraw] = useState("");
  const [searchDeposit, setSearchDeposit] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [withdrawStartDate, setWithdrawStartDate] = useState(null);
  const [withdrawEndDate, setWithdrawEndDate] = useState(null);

  const [openearn, setopenearn] = useState(false);
  const handleopenearn = () => setopenearn(true);
  const handleCloseearn = () => setopenearn(false);

  const [openrefferal, setopenrefferal] = useState(false);
  const handleOpenrefferal = () => setopenrefferal(true);
  const handleCloserefferal = () => setopenrefferal(false);

  const [selectedValue, setSelectedValue] = useState("Earned"); // Default value

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleButtonClick = () => {
    if (selectedValue === "Earned") {
      handleopenearn();
    } else if (selectedValue === "Referral") {
      handleOpenrefferal();
    }
  };

  const path = usercalls();

  const [orderHistory, setOrderHistory] = useState([]);

  const [orderHisPage, setOrderHisPage] = useState(0);

  const [withdrawHistory, setWithdrawHistory] = useState({});
  const [depositHistory, setDepositHistory] = useState([]);

  const getTradeHistory = async (pages) => {
    var pg;
    if (pages == "0") {
      pg = 0;
    }
    if (pages) {
      setPage(0);
    }

    try {
      setLoad(true);
      setOrderHistory([]);
      const url = `${consts.BackendUrl}/ownTrade/orderhistory?page=${pg ? pg + 1 : page + 1
        }&limit=10`;
      var payload = {};

      if (pages == "reset") {
        payload = {
          type: "all",
          side: "",
          order_type: "",
        };
      } else {
        payload = {
          type: trade_type,
          side: status == "all" ? "" : status,
          order_type: order_type == "all" ? "" : order_type,
        };
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setOrderHistory(result?.result?.docs);
        setOrderHisPage(result?.result?.totalDocs);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const getFutureHistory = async (pages) => {
    var pg;
    if (pages == "0") {
      pg = 0;
    }
    if (pages) {
      setPage(0);
    }

    try {
      setLoad(true);
      setOrderHistory([]);
      const url = `${consts.BackendUrl}/ownTrade/futureTradeHistory?page=${pg ? pg + 1 : page + 1
        }&limit=${rowsPerPage}`;
      var payload = {};

      if (pages == "reset") {
        payload = {
          type: "futures",
          side: "",
          order_type: "",
        };
      } else {
        payload = {
          type: "futures",
          side: status == "all" ? "" : status,
          order_type: future_order_type == "all" ? "" : future_order_type,
        };
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success) {
        setOrderHistory(result?.result?.docs);
        setOrderHisPage(result?.result?.totalDocs);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const getWithdrawHistory = async (sts) => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/WithdrawList?page=${page + 1
        }&limit=${rowsPerPage}`;
      const payload = {
        status: sts === "reset" ? "" : status == "all" ? "" : status,
        search: sts === "reset" ? "" : searchWithdraw,
        startDate:
          sts === "reset" ? null : withdrawStartDate?.format("YYYY-MM-DD"),
        endDate: sts === "reset" ? null : withdrawEndDate?.format("YYYY-MM-DD"),
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // console.log(result, "result");
      if (result?.success == true) {
        setWithdrawHistory(result?.result);
        // setHistoryTotal(result?.result?.totalDocs)
        setLoad(false);
      } else {
        setWithdrawHistory({});
        // setHistoryTotal(0)
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const getDepositHistory = async (reset) => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/wallet/getOwnDepositHistory?page=${page + 1
        }&limit=${rowsPerPage}`;
      const payload = {
        search: reset === "reset" ? "" : searchDeposit,
        startDate: reset === "reset" ? null : startDate?.format("YYYY-MM-DD"),
        endDate: reset === "reset" ? null : endDate?.format("YYYY-MM-DD"),
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // console.log(result, "result");
      if (result?.success == true) {
        setDepositHistory(result?.result);
        setLoad(false);
      } else {
        setDepositHistory([]);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      console.log(error, "error");
      setLoad(false);
    }
  };

  const getInstantBuySell = async (type) => {
    try {
      setLoad(true);
      const url = `${consts.BackendUrl}/get-instatant-orders?page=${page + 1
        }&limit=${rowsPerPage}`;
      const payload = { search: type === 2 ? "" : search };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      // console.log(result);
      if (result.success) {
        setFiatHistory(result?.result);
        setLoad(false);
      } else {
        toast.error(result.message);
        setLoad(false);
      }
      setLoad(false);
    } catch (error) {
      setLoad(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (value === 0) {
      getTradeHistory();
    }
    if (value === 1) {
      getFutureHistory();
    }
    if (value === 2) {
      getWithdrawHistory();
    }
    if (value === 3) {
      // console.log(depositHistory);
      getDepositHistory();
    }
    if (value === 4) {
      getInstantBuySell();
    }
  }, [page, value, rowsPerPage]);

  useEffect(() => {
    setPage(0);
    setRowsPerPage(10);
  }, [value]);

  return (
    <div className="menu-responsive">
      <Header />
      {load && <Loader />}
      <ToastContainer />
      <div className="main_flx">
        <Sidebar />
        <div style={{ width: "100%" }} className="history-page">
          <div
            className="abvbar split_half display-2 flex-wrap"
            style={{ margin: 0 }}
          >
            <h6>History</h6>
          </div>
          <div className="split_half mt-30">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              className="deposit-tab"
              sx={{ pb: 3 }}
            >
              <Tab label="Trade History" {...a11yProps(0)} />
              <Tab label="Future History" {...a11yProps(1)} />
              <Tab label="withdraw History" {...a11yProps(2)} />
              <Tab label="Deposit Crypto History" {...a11yProps(3)} />
              <Tab label="Instant Buy/Sell History" {...a11yProps(4)} />
              {/* <Tab label="Deposit Fiat History" {...a11yProps(3)} /> */}
              {/* <Tab label="withdraw Fiat History" {...a11yProps(4)} /> */}
              {/* <Tab label="Staking Rewards Claim" {...a11yProps(5)} /> */}
            </Tabs>
            <CustomTabPanel value={value} index={0}>
              <div className="custom_tabs">
                <div className="tab-content">
                  <>
                    <div className="history-tab-top">
                      <Grid
                        container
                        spacing={1}
                        sx={{ alignItems: "flex-end", mb: 3 }}
                      >
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Side</label>
                          <div
                            className="custom_select"
                            style={{ marginTop: "10px" }}
                          >
                            <FormControl fullWidth>
                              <Select
                                className="bord-li"
                                fullWidth
                                value={status}
                                onChange={handleChangeStatus}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    padding: "7px 11px ",

                                    fontSize: "14px !important",
                                  },
                                }}
                              >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="buy">Buy</MenuItem>
                                <MenuItem value="sell">Sell</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Order Type</label>
                          <div
                            className="custom_select"
                            style={{ marginTop: "10px" }}
                          >
                            <FormControl fullWidth>
                              <Select
                                className="bord-li"
                                fullWidth
                                value={order_type}
                                onChange={handleChangeOrderType}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    padding: "7px 11px ",

                                    fontSize: "14px !important",
                                  },
                                }}
                              >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="limit">Limit</MenuItem>
                                <MenuItem value="market">Market</MenuItem>
                                <MenuItem value="stop-limit">
                                  Stop-Limit
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label> Trade Type</label>
                          <div
                            className="custom_select"
                            style={{ marginTop: "10px" }}
                          >
                            <FormControl fullWidth>
                              <Select
                                className="bord-li"
                                fullWidth
                                value={trade_type}
                                onChange={handleChangeTradeType}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    padding: "7px 11px ",

                                    fontSize: "14px !important",
                                  },
                                }}
                              >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="spot">Spot</MenuItem>
                                <MenuItem value="margin">Margin</MenuItem>
                                {/* <MenuItem value="future">Future</MenuItem> */}
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>

                        {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Start Date</label>
                          <div className="custom-datepicker">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker />
                            </LocalizationProvider>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>End Date</label>
                          <div className="custom-datepicker">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              {" "}
                              <DatePicker />
                            </LocalizationProvider>
                          </div>
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={8} lg={12} xl={4}>
                          <div className="history-search mt-10">
                            <div className="d-flex gap-10 justi-c">
                              <Button
                                onClick={() => {
                                  getTradeHistory("0");
                                }}
                              >
                                Search
                              </Button>
                              <Button
                                className="reset-btn"
                                onClick={() => {
                                  setOrder_type("all");
                                  setTrade_type("all");
                                  setStatus("all");
                                  getTradeHistory("reset");
                                }}
                              >
                                Reset
                              </Button>
                            </div>
                            {/* <Button>
                              Download Excel
                            </Button> */}
                          </div>
                        </Grid>
                      </Grid>
                    </div>

                    <TableContainer
                      sx={{
                        margin: "20px 0",
                        borderRadius: "5px",
                        border: "1px solid var(--brd-new)",
                      }}
                    >
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="simple table"
                        className="deposit-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Date & Time</TableCell>
                            <TableCell> Pair</TableCell>
                            <TableCell> Trade Type</TableCell>
                            <TableCell> Order Type</TableCell>
                            <TableCell>Side</TableCell>
                            <TableCell>Order Price</TableCell>
                            <TableCell>Order Quantity</TableCell>
                            <TableCell>Fee</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {orderHistory?.length > 0 ? (
                            orderHistory?.map((row) => (
                              <TableRow className="tr_row">
                                <TableCell>
                                  {" "}

                                  {getTimeFormat(row?.createdAt)}
                                  {/* {row?.createdAt?.split("T")[0]}{" "}
                                  {row?.createdAt
                                    ?.split("T")[1]
                                    ?.split(":")
                                    ?.slice(0, 2)
                                    ?.join(":")}{" "} */}
                                </TableCell>
                                <TableCell>
                                  <div className="d-flex gap-10">
                                    <div>{row.pair}</div>
                                  </div>
                                </TableCell>
                                <TableCell>{Capitalize(row.trade)}</TableCell>
                                <TableCell>
                                  {Capitalize(row.order_type)}
                                </TableCell>
                                <TableCell>
                                  {Capitalize(row.trade_type)}
                                </TableCell>
                                <TableCell>{row.price > 0 ? `${row.price} ${row?.pair?.split('_')[1]}` : "-"}</TableCell>
                                <TableCell>{row.volume} {" "}{row?.pair?.split('_')[0]}</TableCell>
                                <TableCell>
                                  {Number(row.fees)?.toFixed(8)}{" "}
                                  {row?.fee_taken_Asset}
                                </TableCell>
                                <TableCell
                                  className={
                                    row?.status?.toLowerCase() != "canceled"
                                      ? "green"
                                      : "red"
                                  }
                                >
                                  {row.status === "canceled"
                                    ? "Cancelled"
                                    : row.status
                                      ? Capitalize(row?.status)
                                      : "Completed"}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow className="tr_row text-center">
                              <TableCell align="center" colSpan={7}>
                                <img src={noodata} alt="nodata" />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={orderHisPage}
                        rowsPerPage={10}
                        page={page}
                        onPageChange={handleChangePage}
                      // onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableContainer>
                  </>
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <div className="custom_tabs">
                <div className="tab-content">
                  <>
                    <div className="history-tab-top">
                      <Grid
                        container
                        spacing={1}
                        sx={{ alignItems: "flex-end", mb: 3 }}
                      >
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Side</label>
                          <div
                            className="custom_select"
                            style={{ marginTop: "10px" }}
                          >
                            <FormControl fullWidth>
                              <Select
                                className="bord-li"
                                fullWidth
                                value={status}
                                onChange={handleChangeStatus}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    padding: "7px 11px ",

                                    fontSize: "14px !important",
                                  },
                                }}
                              >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="buy">Buy</MenuItem>
                                <MenuItem value="sell">Sell</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Order Type</label>
                          <div
                            className="custom_select"
                            style={{ marginTop: "10px" }}
                          >
                            <FormControl fullWidth>
                              <Select
                                className="bord-li"
                                fullWidth
                                value={future_order_type}
                                onChange={handleChangeFutureOrderType}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    padding: "7px 11px ",

                                    fontSize: "14px !important",
                                  },
                                }}
                              >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="limit">Limit</MenuItem>
                                <MenuItem value="market">Market</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={12} md={8} lg={12} xl={4}>
                          <div className="history-search mt-10">
                            <div className="display-1">
                              <Button
                                onClick={() => {
                                  getFutureHistory("0");
                                }}
                              >
                                Search
                              </Button>
                              <Button
                                className="reset-btn"
                                onClick={() => {
                                  setFuture_Order_type("all");
                                  setStatus("all");
                                  getFutureHistory("reset");
                                }}
                              >
                                Reset
                              </Button>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>

                    <TableContainer
                      sx={{
                        margin: "20px 0",
                        borderRadius: "5px",
                        border: "1px solid var(--border-clr)",
                      }}
                    >
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="simple table"
                        className="deposit-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Date & Time</TableCell>
                            <TableCell> Pair</TableCell>
                            <TableCell> Order Type</TableCell>
                            <TableCell>Side</TableCell>
                            <TableCell>Order Price</TableCell>
                            <TableCell>Order Quantity</TableCell>
                            <TableCell>Fee</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {orderHistory?.length > 0 ? (
                            orderHistory?.map((row) => (
                              <TableRow className="tr_row">
                                <TableCell>
                                  {" "}
                                  {getTimeFormat(row?.createdAt)}
                                  {/* {row?.createdAt?.split("T")[0]}{" "}
                                  {row?.createdAt
                                    ?.split("T")[1]
                                    ?.split(":")
                                    ?.slice(0, 2)
                                    ?.join(":")}{" "} */}
                                </TableCell>
                                <TableCell>
                                  <div className="d-flex gap-10">
                                    <div>{row.pair}</div>
                                  </div>
                                </TableCell>
                                <TableCell>
                                  {Capitalize(row.order_type)}
                                </TableCell>
                                {/* <>
                                  {row?.positionSide === "long" &&
                                    row?.trade_type === "sell" && (
                                      <TableCell align="center">
                                        Close Long
                                      </TableCell>
                                    )}

                                  {row?.positionSide === "short" &&
                                    row?.trade_type === "buy" && ( // correct
                                      <TableCell align="center">
                                        Close Short
                                      </TableCell>
                                    )}

                                  {row?.positionSide === "long" &&
                                    row?.trade_type === "buy" && (
                                      <TableCell align="center">
                                        Open Long
                                      </TableCell>
                                    )}

                                  {row?.positionSide === "short" &&
                                    row?.trade_type === "sell" && (
                                      <TableCell align="center">
                                        Open Short
                                      </TableCell>
                                    )}
                                </> */}
                                <TableCell>
                                  {Capitalize(row.trade_type)}
                                </TableCell>
                                <TableCell>{row.price}</TableCell>
                                <TableCell>{row.volume}</TableCell>
                                <TableCell>
                                  {Number(row.fees)?.toFixed(8)}{" "}
                                  {row?.fee_taken_Asset}
                                </TableCell>
                                <TableCell
                                  className={
                                    row?.status?.toLowerCase() != "canceled"
                                      ? "green"
                                      : "red"
                                  }
                                >
                                  {row.status
                                    ? Capitalize(
                                      row?.status?.toLowerCase() == "canceled"
                                        ? "Cancelled"
                                        : row?.status
                                    )
                                    : "Completed"}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow className="tr_row text-center">
                              <TableCell align="center" colSpan={7}>
                                <img src={noodata} alt="nodata" />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={orderHisPage}
                        rowsPerPage={10}
                        page={page}
                        onPageChange={handleChangePage}
                      // onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableContainer>
                  </>
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <div className="custom_tabs">
                <div className="tab-content">
                  <>
                    <div className="history-tab-top">
                      <Grid
                        container
                        spacing={1}
                        sx={{ alignItems: "flex-end", mb: 3 }}
                      >
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Status</label>
                          <div
                            className="bord-li custom_select"
                            style={{ marginTop: "10px" }}
                          >
                            <FormControl fullWidth>
                              <Select
                                className=""
                                fullWidth
                                value={status}
                                onChange={handleChangeStatus}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    padding: "7px 11px ",

                                    fontSize: "14px !important",
                                  },
                                }}
                              >
                                <MenuItem value="all">All Status</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="Approved">Approved</MenuItem>
                                <MenuItem value="Cancelled">Rejected</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Search</label>

                          <div className="searchbox-history">
                            <TextField
                              className="bord-li"
                              fullWidth
                              value={searchWithdraw}
                              onChange={(e) =>
                                setSearchWithdraw(e.target.value)
                              }
                              placeholder="Currency, Network and Transaction ID"
                              sx={{
                                "& .MuiInputBase-input": {
                                  padding: "9px 11px ",
                                  fontSize: "14px !important",
                                },
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>Start Date</label>
                          <div className="custom-datepicker">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                className="bord-li"
                                value={withdrawStartDate}
                                onChange={(e) => {
                                  setWithdrawStartDate(e);
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                          <label>End Date</label>
                          <div className="custom-datepicker">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              {" "}
                              <DatePicker
                                className="bord-li"
                                value={withdrawEndDate}
                                onChange={(e) => {
                                  setWithdrawEndDate(e);
                                }}
                              />
                            </LocalizationProvider>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={8} lg={12} xl={4}>
                          <div className="history-search mt-10">
                            <div className="d-flex gap-10 justi-c">
                              <Button onClick={() => getWithdrawHistory()}>
                                Search
                              </Button>
                              <Button
                                className="reset-btn"
                                onClick={() => {
                                  setWithdrawStartDate(null);
                                  setWithdrawEndDate(null);
                                  setStatus("all");
                                  setSearchWithdraw("");
                                  getWithdrawHistory("reset");
                                }}
                              >
                                Reset
                              </Button>
                            </div>
                            {/* <Button>Download Excel</Button> */}
                          </div>
                        </Grid>
                      </Grid>
                    </div>

                    <TableContainer
                      sx={{
                        margin: "20px 0",
                        borderRadius: "5px",
                        border: "1px solid var(--border-clr)",
                      }}
                    >
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="simple table"
                        className="deposit-table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>Date & Time</TableCell>
                            <TableCell>Currency</TableCell>
                            <TableCell>Network</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Fees</TableCell>
                            <TableCell>Transaction ID</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {withdrawHistory?.docs?.length > 0 ? (
                            withdrawHistory?.docs?.map((row) => (
                              <TableRow className="tr_row">
                                <TableCell>
                                  {" "}
                                  {getTimeFormat(row?.createdAt)}{" "}
                                </TableCell>
                                <TableCell>
                                  <div className="d-flex gap-10">
                                    <div>
                                      <ImageWithFallback
                                        size={25}
                                        src={
                                          consts?.imageurl +
                                          row?.Coinname +
                                          ".png"
                                        }
                                        alt={row?.Coinname}
                                        name={row?.Coinname}
                                        className="coin-img"
                                      />
                                    </div>
                                    <div>{row?.Coinname}</div>
                                  </div>
                                </TableCell>
                                <TableCell>{row?.Network}</TableCell>

                                <TableCell>{row?.Address}</TableCell>
                                <TableCell>{decimal(row?.Amount)}</TableCell>
                                <TableCell>{decimal(row?.Fees)}</TableCell>
                                <TableCell>{row?.txId}</TableCell>
                                <TableCell
                                  className={
                                    row?.Status?.toLowerCase() === "approved"
                                      ? "green"
                                      : row?.Status?.toLowerCase() === "pending"
                                        ? "yellow"
                                        : "red"
                                  }
                                >
                                  {row?.Status}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow className="tr_row text-center">
                              <TableCell align="center" colSpan={7}>
                                <img src={noodata} alt="nodata" />
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[]}
                        component="div"
                        count={withdrawHistory?.totalDocs}
                        rowsPerPage={10}
                        page={page}
                        onPageChange={handleChangePage}
                      // onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableContainer>
                  </>
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <>
                <div className="history-tab-top">
                  <Grid
                    container
                    spacing={1}
                    sx={{ alignItems: "flex-end", mb: 3 }}
                  >
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                      <label>Search</label>

                      <div className="searchbox-history">
                        <TextField
                          className="bord-li"
                          fullWidth
                          value={searchDeposit}
                          onChange={(e) => setSearchDeposit(e.target.value)}
                          placeholder="Address, Currency and Transaction ID"
                          sx={{
                            "& .MuiInputBase-input": {
                              padding: "9px 11px ",
                            },
                            fontSize: "14px !important",
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
                      <label>Start Date</label>
                      <div className="custom-datepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="bord-li"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e);
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
                      <label>End Date</label>
                      <div className="custom-datepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          {" "}
                          <DatePicker
                            className="bord-li"
                            value={endDate}
                            onChange={(e) => {
                              setEndDate(e);
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                      <div className="history-search mt-10">
                        <div className="d-flex gap-10 justi-c">
                          <Button onClick={() => getDepositHistory()}>
                            Search
                          </Button>
                          <Button
                            className="reset-btn"
                            onClick={() => {
                              setStartDate(null);
                              setEndDate(null);
                              setSearchDeposit("");
                              getDepositHistory("reset");
                            }}
                          >
                            Reset
                          </Button>
                        </div>
                        {/* <Button>Download Excel</Button> */}
                      </div>
                    </Grid>
                  </Grid>
                </div>

                <TableContainer
                  sx={{
                    margin: "20px 0",
                    borderRadius: "5px",
                    border: "1px solid var(--border-clr)",
                  }}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    className="deposit-table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>S.No</TableCell>
                        <TableCell>Date & Time</TableCell>
                        <TableCell>Currency</TableCell>
                        <TableCell align="center">Address</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Transaction ID</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {depositHistory?.docs?.length > 0 ? (
                        depositHistory?.docs?.map((row, index) => (
                          <TableRow className="tr_row">
                            <TableCell>
                              {" "}
                              {page == 0
                                ? index + 1
                                : page * rowsPerPage + index + 1}{" "}
                            </TableCell>
                            <TableCell>
                              {" "}
                              {getTimeFormat(row?.createdAt)}{" "}
                            </TableCell>

                            <TableCell>
                              <div className="d-flex gap-10">
                                <div>
                                  <ImageWithFallback
                                    src={consts?.imageurl + row?.asset + ".png"}
                                    alt={row?.asset}
                                    name={row?.asset}
                                    size={20}
                                    className="coin-img"
                                  />
                                </div>
                                <div>{row?.asset}</div>
                              </div>
                            </TableCell>
                            <TableCell align="center">
                              {row?.contractAddress || "- - -"}
                            </TableCell>
                            <TableCell>{row?.amount}</TableCell>
                            <TableCell>
                              {limitLength(row?.transactionHash)}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="tr_row text-center">
                          <TableCell align="center" colSpan={7}>
                            <img src={noodata} alt="nodata" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={depositHistory?.totalDocs}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                  // onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </>
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={4}>
              <>
                <div className="history-tab-top">
                  <Grid
                    container
                    spacing={1}
                    sx={{ alignItems: "flex-end", mb: 3 }}
                  >
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                      <label>Search</label>

                      <div className="searchbox-history">
                        <TextField
                          fullWidth
                          placeholder="Address, Currency,Transaction ID"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "gray !important", // default
                              },
                              "& input::placeholder": {
                                color: "gray",
                                opacity: 1, // to ensure it's not faded
                              },
                            },
                            "& .MuiInputBase-input": {
                              padding: "9px 11px ",
                            },
                            fontSize: "14px !important",
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
                      <label>Start Date</label>
                      <div className="custom-datepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "gray !important", // default
                                },
                                "& input::placeholder": {
                                  color: "gray",
                                  opacity: 1, // to ensure it's not faded
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
                      <label>End Date</label>
                      <div className="custom-datepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          {" "}
                          <DatePicker
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "gray !important", // default
                                },
                                "& input::placeholder": {
                                  color: "gray",
                                  opacity: 1, // to ensure it's not faded
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                      <div className="history-search mt-10">
                        <div className="d-flex gap-10 justi-c">
                          <Button>Search</Button>
                          <Button className="reset-btn">Reset</Button>
                        </div>
                        <Button>Download Excel</Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>

                <TableContainer
                  sx={{
                    margin: "20px 0",
                    borderRadius: "5px",
                    border: "1px solid var(--border-clr)",
                  }}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    className="deposit-table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>S.No</TableCell>
                        <TableCell>Date & Time</TableCell>
                        <TableCell>Currency</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Transaction ID</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {history.length > 0 ? (
                        paginatedData.map((row) => (
                          <TableRow className="tr_row">
                            <TableCell> {row.sno} </TableCell>
                            <TableCell> {row.date} </TableCell>

                            <TableCell>
                              <div className="d-flex gap-10">
                                <div>
                                  <img
                                    src={row.currency}
                                    alt={row.currencyName}
                                    className="coin-img"
                                  />
                                </div>
                                <div>{row.currencyName}</div>
                              </div>
                            </TableCell>
                            <TableCell>{row.address}</TableCell>
                            <TableCell>{row.amount}</TableCell>
                            <TableCell>{row.txid}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="tr_row text-center">
                          <TableCell align="center" colSpan={7}>
                            <img src={nodata} alt="nodata" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </>
            </CustomTabPanel> */}
            <CustomTabPanel value={value} index={4}>
              <>
                <div className="history-tab-top">
                  <Grid
                    container
                    spacing={1}
                    sx={{ alignItems: "flex-end", mb: 3 }}
                  >
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                      <label>Search</label>

                      <div className="searchbox-history">
                        <TextField
                          fullWidth
                          placeholder="Fiat Currency and Crypto Currency"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "gray !important", // default
                              },
                              "& input::placeholder": {
                                color: "gray",
                                opacity: 1, // to ensure it's not faded
                              },
                            },
                            "& .MuiInputBase-input": {
                              padding: "9px 11px ",
                              color: "white",
                              fontSize: "14px !important",
                            },
                          }}
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                      <div className="history-search mt-10">
                        <div className="d-flex gap-10 justi-c">
                          <Button
                            onClick={() => {
                              getInstantBuySell();
                              setPage(0);
                            }}
                          >
                            Search
                          </Button>
                          <Button
                            onClick={() => {
                              setSearch("");
                              getInstantBuySell(2);
                            }}
                            className="reset-btn"
                          >
                            Reset
                          </Button>
                        </div>
                        {/* <Button>
                          Download Excel
                        </Button> */}
                      </div>
                    </Grid>
                  </Grid>
                </div>

                <TableContainer
                  sx={{
                    margin: "20px 0",
                    borderRadius: "5px",
                    border: "1px solid var(--brd-new)",
                  }}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    className="deposit-table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>S.No</TableCell>
                        <TableCell>Date & Time</TableCell>
                        <TableCell>Fiat</TableCell>
                        <TableCell>Crypto</TableCell>
                        <TableCell>Fiat Amount</TableCell>
                        <TableCell>Crypto Amount</TableCell>
                        <TableCell>Status</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {fiatHistory?.docs?.length > 0 ? (
                        fiatHistory?.docs?.map((row, ind) => (
                          <TableRow className="tr_row">
                            <TableCell> {ind + 1} </TableCell>
                            <TableCell>
                              {" "}
                              {getTimeFormat(row.createdAt)}{" "}
                            </TableCell>
                            <TableCell>{row.fiatCurrency}</TableCell>
                            <TableCell>{row.cryptoCurrency}</TableCell>
                            {/* <TableCell>
                              <div className="d-flex gap-10">
                                <div>
                                  <img
                                    src={row.currency}
                                    alt={row.currencyName}
                                    className="coin-img"
                                  />
                                </div>
                                <div>{row.currencyName}</div>
                              </div>
                            </TableCell> */}
                            <TableCell>{row.fiatAmount}</TableCell>
                            <TableCell>{row.cryptoAmount}</TableCell>
                            {/* <TableCell>{row.txid}</TableCell> */}
                            <TableCell
                              className={
                                row.status === "order_complete" ? "green" : "red"
                              }
                            >
                              {row?.status === "order_failed" ? "Failed" : row?.status === "order_complete" ? "Completed" : row?.status === "order_cancelled" ? "Cancelled" : "Pending"}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="tr_row text-center">
                          <TableCell
                            align="center"
                            sx={{ textAlign: "center !important" }}
                            colSpan={9}
                          >
                            <img src={noodata} alt="nodata" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={fiatHistory.totalDocs}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                  // onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={5}>
              <>
                <div className="history-tab-top">
                  <Grid
                    container
                    spacing={1}
                    sx={{ alignItems: "flex-end", mb: 3 }}
                  >
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={2}>
                      <label>Search</label>

                      <div className="searchbox-history">
                        <TextField
                          fullWidth
                          placeholder="Address, Currency,Transaction ID"
                          sx={{
                            "& .MuiInputBase-input": {
                              padding: "9px 11px ",
                              fontSize: "14px !important",
                            },
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
                      <label>Start Date</label>
                      <div className="custom-datepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} xl={2}>
                      <label>End Date</label>
                      <div className="custom-datepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker />
                        </LocalizationProvider>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={6}>
                      <div className="history-search mt-10">
                        <div className="d-flex gap-10 justi-c">
                          <Button>Search</Button>
                          <Button className="reset-btn">Reset</Button>
                        </div>
                        <Button>Download Excel</Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>

                <TableContainer
                  sx={{
                    margin: "20px 0",
                    borderRadius: "5px",
                    border: "1px solid var(--border-clr)",
                  }}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    className="deposit-table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>S.No</TableCell>
                        <TableCell>Date & Time</TableCell>
                        <TableCell>Fiat</TableCell>
                        <TableCell>Crypto</TableCell>
                        <TableCell>Fiat Amount</TableCell>
                        <TableCell>Crypto Amount</TableCell>
                        <TableCell>Status</TableCell>
                        {/* <TableCell>Transaction ID</TableCell>
                        <TableCell>Status</TableCell> */}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {fiatHistory.length > 0 ? (
                        paginatedData.map((row) => (
                          <TableRow className="tr_row">
                            <TableCell> {row.sno} </TableCell>
                            <TableCell> {row.date} </TableCell>
                            <TableCell>{row.bank}</TableCell>
                            <TableCell>{row.accountno}</TableCell>
                            <TableCell>
                              <div className="d-flex gap-10">
                                <div>
                                  <img
                                    src={row.currency}
                                    alt={row.currencyName}
                                    className="coin-img"
                                  />
                                </div>
                                <div>{row.currencyName}</div>
                              </div>
                            </TableCell>
                            <TableCell>{row.address}</TableCell>
                            <TableCell>{row.amount}</TableCell>
                            <TableCell>{row.txid}</TableCell>
                            <TableCell>{row.status}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="tr_row text-center">
                          <TableCell
                            align="center"
                            sx={{ textAlign: "center !important" }}
                            colSpan={9}
                          >
                            <img src={noodata} alt="nodata" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={6}>
              <>
                <TableContainer
                  sx={{
                    margin: "20px 0",
                    borderRadius: "5px",
                    border: "1px solid var(--border-clr)",
                  }}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    className="deposit-table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Date & Time</TableCell>
                        <TableCell>Currency</TableCell>
                        <TableCell>Staked Amount</TableCell>
                        <TableCell>Monthly Percentage</TableCell>
                        <TableCell>Reward Amount</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {stakeReward.length > 0 ? (
                        paginatedData.map((row) => (
                          <TableRow className="tr_row">
                            <TableCell> {row.date} </TableCell>
                            <TableCell>
                              <div className="d-flex gap-10">
                                <div>
                                  <img
                                    src={row.currency}
                                    alt={row.currencyName}
                                    className="coin-img"
                                  />
                                </div>
                                <div>{row.currencyName}</div>
                              </div>
                            </TableCell>
                            <TableCell>{row.stakeAmount}</TableCell>
                            <TableCell>{row.monthPer}</TableCell>
                            <TableCell>
                              <div className="d-flex gap-10">
                                <div>
                                  <img
                                    src={row.currency}
                                    alt={row.currencyName}
                                    className="coin-img"
                                  />
                                </div>
                                <div>{row.currencyName}</div>
                              </div>
                            </TableCell>

                            <TableCell>{row.rewardAmount}</TableCell>
                            <TableCell>{row.txid}</TableCell>
                            <TableCell>
                              <Button
                                style={{
                                  padding: "10px 20px",
                                  width: "104px",
                                  border: 0,
                                  textTransform: "capitalize",
                                }}
                                className={
                                  row.action === "claim!"
                                    ? "green_bg"
                                    : "grey_btn disable"
                                }
                              >
                                {row.action}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow className="tr_row text-center">
                          <TableCell
                            align="center"
                            sx={{ textAlign: "center !important" }}
                            colSpan={6}
                          >
                            <img src={noodata} alt="nodata" />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </>
            </CustomTabPanel>
          </div>
        </div>
      </div>

      <Footernew />
    </div>
  );
}
